/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-deprecated */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Tabs, RadioButton, Grid, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, useIntl } from 'react-intl';
import CustomTabsSettingsForm from './CustomTabs.settingsForm';
import './customTabs.scss';
import getLocalParams from '../localizationCustoms';
import { arraymove } from '../utils/functions';
import useDidMountEffect from '../../../hooks/useDidMountEffect';

function CustomTabsComp(props) {
  const [tabValue, setTabValue] = useState('');
  const [value, setValue] = useState(props.value);
  const [sessionTabs, setSessionTabs] = useState(JSON.parse(sessionStorage.getItem('policyDetails')));
  const [policies, setPolicies] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [properties, setProperties] = useState([]);
  const [renderTabs, setRenderTabs] = useState('Loading');
  const intl = useIntl();

  const VEHICLE_INJURY_ONLY_TOOLTIP = {
    title: 'Injury Only Claims',
    body: "If you're injured in a car accident and your vehicle wasn't involved, or are injured as a pedestrian/cyclist, regardless of who is at fault, choose this option.",
  };
  const PROPERTY_SOMEWHERE_ELSE_TOOLTIP = {
    title: 'Somewhere else',
    body: "This is a loss that happens at a location other than your insured address. For example, your laptop is stolen while you're working at the local coffee shop, or you lost your ring at the beach.",
  };

  useEffect(() => {
    window.addEventListener('storage', (e) => {
      if (e.key === 'policyDetails') {
        if (e.newValue !== null) {
          const policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
          if (policyDetails.length) {
            setSessionTabs(JSON.parse(sessionStorage.getItem('policyDetails')));
          } else {
            onChangeHandler(null, 'No Policies');
          }
        } else {
          onChangeHandler(null, 'No Policies');
        }
      }
    });
  }, []);

  useEffect(() => {
    const policiesTempArray = [];
    const vehiclesTempArray = [];
    const propertiesTempArray = [];
    const hasOwnProperty = props.value;
    let hasAbOnlyPolicy = false;
    if (sessionTabs) {
      sessionTabs.map((policy) => {
        if (policy.lob === 'PersonalAuto') {
          hasAbOnlyPolicy = policy.policyProvince === 'Ontario' && policy.coverages.hasBasicAccidentBenefits ? true : hasAbOnlyPolicy;
          if (policy.vehicles) {
            if (policy.vehicles.length && policiesTempArray.filter((p) => p.name === 'Vehicle' && p.value === 'Vehicle').length === 0) {
              policiesTempArray.push({ name: 'Vehicle', value: 'Vehicle' });
            }
            policy.vehicles.map((vehicle) => {
              vehiclesTempArray.push(vehicle);
            });
          }
        } else if (policy.lob === 'Homeowners') {
          if (policy.properties) {
            if (policy.properties.length && policiesTempArray.filter((p) => p.name === 'Home' && p.value === 'Home').length === 0
            ) {
              policiesTempArray.push({ name: 'Home', value: 'Home' });
            }
            policy.properties.map((property) => {
              propertiesTempArray.push(property);
            });
          }
        }
      });
      if (hasAbOnlyPolicy) {
        vehiclesTempArray.push({ id: 'injuryOnly', policySystemId: 'injuryOnly', year: 0 });
      }
      if (propertiesTempArray.length) {
        // Adding "Somewhere else"
        propertiesTempArray.push({ id: 'somewhereElse',
          policySystemId: 'somewhereElse',
          address: {
            addressLine1: 'Somewhere else',
            city: '',
            postalCode: '',
            provinceCode: '',
          } });
      }
      if (policiesTempArray.length >= 2) {
        const fromIndex = policiesTempArray.findIndex((policy) => policy.name === 'Vehicle');
        if (policiesTempArray[0].name !== 'Vehicle' && fromIndex) {
          arraymove(policiesTempArray, fromIndex, 0);
        }
      }

      setPolicies(policiesTempArray);
      setVehicles(vehiclesTempArray);
      setProperties(propertiesTempArray);
    }

    if (hasOwnProperty && hasOwnProperty.claim_type === 'Vehicle') {
      setTabValue(hasOwnProperty.claim_type);
      setValue(hasOwnProperty.vehicle.policySystemId);
    } else if (hasOwnProperty && hasOwnProperty.claim_type === 'Home') {
      setTabValue(hasOwnProperty.claim_type);
      setValue(hasOwnProperty.property.policySystemId);
    } else {
      setTabValue('');
      setValue('');
    }
  }, [sessionTabs, props.value]);

  useDidMountEffect(() => {
    if (sessionTabs?.length && policies?.length) {
      setRenderTabs('Render');
    } else {
      setRenderTabs('No policies');
    }
  }, [policies]);

  const onChangeHandler = (v, tab) => {
    let finalObjToBeSubmitted = {};

    if (tab === 'Vehicle') {
      const selectedVehicle = vehicles.find((vehicle) => vehicle.policySystemId === v);
      const { policySystemId, make, model, year, body } = selectedVehicle;
      if (selectedVehicle) {
        finalObjToBeSubmitted = {
          claim_type: 'Vehicle',
          vehicle: {
            year,
            make,
            model,
            body: body?.code,
            policySystemId,
          },
          review: { label: props.component.useReviewLabel ? props.component.reviewLabel : props.component.label, value: year !== 0 ? `${year || ''} ${make || ''} ${model || ''}` : year },
        };
      }
    } else if (tab === 'Home') {
      const selectedProperty = properties.find((property) => property.policySystemId === v);
      if (selectedProperty) {
        const { policySystemId, type, address: { addressLine1, city, provinceCode, postalCode } } = selectedProperty;
        finalObjToBeSubmitted = {
          claim_type: 'Home',
          property: {
            policySystemId,
            type,
            address: {
              addressLine1,
              city,
              postalCode,
              provinceCode,
            },
          },
          review: { label: props.component.useReviewLabel ? props.component.reviewLabel : props.component.label, value: `${addressLine1 || ''} ${city || ''} ${provinceCode || ''} ${postalCode || ''}` },
        };
      }
    } else if (tab === 'No Policies') {
      finalObjToBeSubmitted = {
        claim_type: 'No Policies',
      };
    }

    if (tab !== 'No Policies') {
      setTabValue(tab);
      setValue(v);
    } else {
      setPolicies(null);
    }

    props.onChange(finalObjToBeSubmitted);
  };

  const resetTabValue = () => {
    setValue('');
    props.onChange(null);
  };

  return (

    renderTabs === 'Render' && policies?.length
      ? (
        <div className="tabs-container" id={`id_tabs_comp_${props.component.id}`}>
          {!props.component.hideCustomLabel
            ? (
              <label className="label-question">
                <FormattedMessage id={props.component.label} defaultMessage={props.component.label} />
              </label>
            ) : null}
          <Tabs id={`tabs_${props.component.id}`} defaultTab={policies.length > 1 ? (tabValue === '' || tabValue === 'Vehicle') ? '0' : '1' : '0'}>
            {policies.map((policy) => (
              <Tabs.Tab
                key={`tab_${policy.name}`}
                title={intl.formatMessage({ id: `${policy.name}`, defaultValue: `${policy.name}` })}
                onClose={tabValue === policy.name ? () => resetTabValue() : null}
              >
                {policy.value === 'Vehicle' && (
                  <Grid>
                    <p className="description-tab">
                      <FormattedMessage
                        id="You and/or your vehicle were involved in an accident, damages, or losses. Can't find what you're looking for? Give us a call at "
                        defaultMessage="You and/or your vehicle were involved in an accident, damages, or losses. Can't find what you're looking for? Give us a call at "
                      />
                      <a href="tel:1-844-766-6384" className="phoneNumber">1-844-766-6384</a>.
                    </p>
                    <div className="label-question">
                      <FormattedMessage id="Which vehicle was involved?" defaultMessage="Which vehicle was involved?" />
                    </div>
                    {vehicles.length > 0 && vehicles.map((vehicle) => (
                      <RadioButton
                        secondary
                        id={`id_radiobutton_${Math.random() * 0xfffffffffffff}`}
                        key={`key_radiobutton_${Math.random() * 0xfffffffffffff}`}
                        value={vehicle.policySystemId}
                        onChange={(v) => onChangeHandler(v, policy.value)}
                        checked={value === vehicle.policySystemId}
                      >
                        {`${vehicle.year || vehicle.year === 0 ? vehicle.policySystemId === 'injuryOnly' ? intl.formatMessage({ id: 'Injury only', defaultMessage: 'Injury only' }) : vehicle.year : ''}${vehicle.make ? ` ${vehicle.make}` : ''}${vehicle.model ? ` ${vehicle.model}` : ''}`}
                        {vehicle.policySystemId === 'injuryOnly'
                          ? (
                            <Tooltip id="injuryOnly_tooltip" primary title={intl.formatMessage({ id: VEHICLE_INJURY_ONLY_TOOLTIP.title, defaultValue: VEHICLE_INJURY_ONLY_TOOLTIP.title })}>
                              <FormattedMessage id={VEHICLE_INJURY_ONLY_TOOLTIP.body} defaultMessage={VEHICLE_INJURY_ONLY_TOOLTIP.body} />
                            </Tooltip>
                          )
                          : null}
                      </RadioButton>
                    ))}
                  </Grid>
                )}
                {policy.value === 'Home' && (
                  <Grid>
                    <p className="description-tab">
                      <FormattedMessage
                        id="Your property was damaged or lost, or someone on your property was injured."
                        defaultMessage="Your property was damaged or lost, or someone on your property was injured. Can't find what you're looking for? Give us a call at "
                      />
                      <a href="tel:1-844-766-6384" className="phoneNumber">1-844-766-6384</a>.
                    </p>
                    <div className="label-question">
                      <FormattedMessage id="Which property was it?" defaultMessage="Which property was it?" />
                    </div>
                    {properties.length > 0 && properties.map((property) => (
                      <RadioButton
                        secondary
                        id={`id_radiobutton_${Math.random() * 0xfffffffffffff}`}
                        key={`key_radiobutton_${Math.random() * 0xfffffffffffff}`}
                        value={property.policySystemId}
                        onChange={(v) => onChangeHandler(v, policy.value)}
                        checked={value === property.policySystemId}
                      >
                        <span className="fs-exclude">{`${property.address.addressLine1 ? property.address.addressLine1 === 'Somewhere else' ? intl.formatMessage({ id: property.address.addressLine1, defaultMessage: property.address.addressLine1 }) : property.address.addressLine1 : ''}${property.address.city ? ` ${property.address.city}` : ''}${property.address.provinceCode ? ` ${property.address.provinceCode}` : ''}${property.address.postalCode ? ` ${property.address.postalCode}` : ''}`}</span>
                        {property.policySystemId === 'somewhereElse'
                          ? (
                            <Tooltip id="somewhereElse_tooltip" primary title={intl.formatMessage({ id: PROPERTY_SOMEWHERE_ELSE_TOOLTIP.title, defaultValue: PROPERTY_SOMEWHERE_ELSE_TOOLTIP.title })}>
                              <FormattedMessage id={PROPERTY_SOMEWHERE_ELSE_TOOLTIP.body} defaultMessage={PROPERTY_SOMEWHERE_ELSE_TOOLTIP.body} />
                            </Tooltip>
                          )
                          : null}
                      </RadioButton>
                    ))}
                  </Grid>
                )}
              </Tabs.Tab>
            ))}
          </Tabs>
        </div>
      ) : renderTabs === 'No policies' ? <div className="tabs-container" id={`id_tabs_comp_${props.component.id}`}> <p className="no-policies"><FormattedMessage id="Sorry, we couldn't find any active policies for this date. Please check the date of the incident and try again or give us a call at " defaultMessage="Sorry, we couldn't find any active policies for this date. Please check the date of the incident and try again or give us a call at " /><a href="tel:1-844-766-6384">1-844-766-6384</a>.</p></div> : null
  );
}

export default class TabsComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'CustomTabs',
      group: 'layout',
      icon: 'folder-o',
      weight: 50,
      documentation: '/userguide/forms/layout-components#tabs',
      schema: TabsComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
              */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customtabs',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomTabsSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */

  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomTabsComp
          inputRef={(refer) => {
            instance = refer;
          }}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataForSetting || this.dataValue} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
